import React,  { useEffect }  from 'react'
import cookies from 'js-cookie'
import { Routes, Route, Navigate, BrowserRouter} from "react-router-dom";
import {languages} from './i18n.js'
import HomePage  from './pages/Homepage';
import AboutPage from './pages/AboutPage';
import ErrorPage from './pages/ErrorPage';
import DataPage from './pages/DataPage.jsx';
import CountriesPage from './pages/CountriesPage.jsx';
import OneCountryPage from './pages/OneCountryPage.jsx';
import OrganizationsPage from './pages/OrganizationsPage.jsx';
//import OneOrganizationPage from './pages/OneOrganizationPage.jsx';
import GlossaryPage from './pages/GlossaryPage.jsx';
import ResourcesPage from './pages/ResourcesPage.jsx';
import DisclaimerPage from './pages/DisclaimerPage.jsx';
import MultilanguageNavigationBar from './components/NavBar'
import Footer from './components/Footer'
import './App.css'; 
import Row from 'react-bootstrap/Row';



export default function App() {

  const currentLanguageCode = cookies.get('i18next') ||  'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const currentLangTitle = languages.find((l) => l.code === currentLanguageCode).name
  

    useEffect(() => {
      document.body.dir = currentLanguage.dir || 'ltr'
     
    }, [currentLanguage])

  return (
    <div >
       <div>
    
     <MultilanguageNavigationBar  lang={currentLanguageCode} langTitle={currentLangTitle}/>
     </div>

     {/* <div className="App"> */}
    
     <Routes>

     <Route
        path="*"
        element={<Navigate to="/silvagris/en" replace />}
/>
      <Route path={`/silvagris/${currentLanguageCode}/`} element={<HomePage lang={currentLanguageCode} />} />
      <Route path={`/silvagris/${currentLanguageCode}/about/background`} element={<AboutPage  lang={currentLanguageCode} argument="background" />} />
      <Route path={`/silvagris/${currentLanguageCode}/about/monitoring-framework`} element={<AboutPage lang={currentLanguageCode} argument="monitoring-framework"/>} />

      <Route path={`/silvagris/${currentLanguageCode}/data/policies-responses/:id`} element={<DataPage lang={currentLanguageCode} argument="policies-responses" coverage="global" target="availability-of_data"/>} />
      <Route path={`/silvagris/${currentLanguageCode}/data/species/:id`} element={<DataPage lang={currentLanguageCode} argument="species" coverage="global" species="" />} />

      <Route path={`/silvagris/${currentLanguageCode}/countries`} element={<CountriesPage lang={currentLanguageCode} />} />

      <Route path={`/silvagris/${currentLanguageCode}/countries/:id`} element={<OneCountryPage  lang={currentLanguageCode} />} />

      <Route path={`/silvagris/${currentLanguageCode}/organizations`} element={<OrganizationsPage lang={currentLanguageCode} />} />

      {/* <Route path={`/${currentLanguageCode}/organizations/:id`} element={<OneOrganizationPage  lang={currentLanguageCode} />} /> */}
      <Route path={`/silvagris/${currentLanguageCode}/glossary`} element={<GlossaryPage lang={currentLanguageCode} />} />

      <Route path={`/silvagris/${currentLanguageCode}/resources/publications`} element={<ResourcesPage lang={currentLanguageCode} argument="publications" />} />
      <Route path={`/silvagris/${currentLanguageCode}/resources/learning`} element={<ResourcesPage lang={currentLanguageCode} argument="learning"/>} />
      <Route path={`/silvagris/${currentLanguageCode}/resources/external-resources`} element={<ResourcesPage lang={currentLanguageCode} argument="external-resources"/>} />
      <Route path={`/silvagris/${currentLanguageCode}/resources/networks`} element={<ResourcesPage lang={currentLanguageCode} argument="networks"/>} />

      <Route path={`/silvagris/${currentLanguageCode}/disclaimer`} element={<DisclaimerPage lang={currentLanguageCode} />} />
      
    
     

        
      
      <Route path="*" element={<ErrorPage />} />
      </Routes>
    
      {/* </div> */}

      <Row style={{  paddingTop:"5rem" , boxShadow: "0 15px 20px -20px #9d9a9a" }}className="d-flex justify-content-between"></Row>
      <Footer lang={currentLanguageCode} />
   




   
    </div>
  )
}